import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../Redux/Actions/AuthActions';
import './Login.css';
import logo from "../image/bookly_logo.png";

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(login({ email, password, targetRole: 'admin' }, navigate));
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 register-background">
      <div className="register-container shadow rounded p-5 text-center border border-danger">
        <img src={logo} alt="Bookly Logo" className="mb-4 login-logo-img" />
        <h4 className="mb-4 text-danger font-weight-bold">🛡️ Espace Administration</h4>

        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3 text-start">
            <Form.Label>Adresse Email Admin</Form.Label>
            <Form.Control
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder="admin@bookly.com"
              value={email}
              className="input-field"
              required
            />
          </Form.Group>

          <Form.Group className="mb-4 text-start">
            <Form.Label>Mot de passe</Form.Label>
            <Form.Control
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="••••••••"
              value={password}
              className="input-field"
              required
            />
          </Form.Group>

          <Button variant="danger" type="submit" className="w-100 btn-submit mb-3 bg-danger" style={{ boxShadow: '0 4px 15px rgba(220, 53, 69, 0.2)' }}>
            Se connecter (Admin)
          </Button>

          <div className="text-center mt-4 text-muted" style={{ fontSize: '13.5px' }}>
            <span>Retourner à la <Link to="/Login">Connexion Client</Link></span>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AdminLogin;
